import { Component, Vue } from 'vue-property-decorator';
import NavigationSearch from '../navigation-search/navigation-search.vue';
import FilterVersion from '../../../versioning/components/filter-version/filter-version.vue';

@Component({
	components: {
		'navigation-search': NavigationSearch,
		'filter-version': FilterVersion
	}
})
export default class NavigationFilters extends Vue {}
